(function (module) {
    'use strict';

    function ForgotPasswordConfig($stateProvider, $translatePartialLoaderProvider) {

        // Route
        $stateProvider
            .state('forgot-password', {
                url: '/forgot-password',
                data: {
                    pageTitle: 'FORGOT_PASSWORD.PAGE_TITLE'
                },
                views: {
                    'main@': {
                        templateUrl: '/js/components/layouts/content-only.html',
                        controller: 'MainController as $ctrl'
                    },
                    'content@forgot-password': {
                        templateUrl: '/js/authentication/forgot-password/forgot-password.html',
                        controller: 'ForgotPasswordCtrl as $ctrl'
                    }
                },
                bodyClass: 'page--forgot-password'
            });
        // Translations
        $translatePartialLoaderProvider.addPart('/js/authentication/forgot-password');
    }

    function ForgotPasswordCtrl(User, $state) {

        this.resetPassword = ()=> {

            User
                .forgotPassword({email: this.user.email.toLowerCase() }).$promise
                .then((response)=> {

                    // needs to go to new state - ideally dynamic where we can say this is about new password, password veryfication or anything else..
                    $state.go('verify-email');

                })
                .catch((response)=> {
                    if (response.status === 404) {
                        $state.go('verify-email');

                    }
                    // TODO: handle error

                });

        };

    }

    module
        .config(ForgotPasswordConfig)
        .controller('ForgotPasswordCtrl', ForgotPasswordCtrl);

})(angular.module('rocket.components'));
